export enum FontRecommededFunction {
    'Display' = 0,
    'Headlines' = 1,
    'Subhead' = 2,
    'Poster' = 3,
    'Text' = 4,
    'Body' = 5,
    'Initials' = 6,
    'Agate' = 7,
    'Captions' = 8,
    'Titling' = 9,
    'Code' = 10,
    'Signage' = 11,
}
export function isFontRecommededFunction(
    value: unknown
): value is FontRecommededFunction {
    return typeof value === 'number' && value in FontRecommededFunction;
}
export const FONT_RECOMMENDED_FUNCTIONS = Object.values(
    FontRecommededFunction
).filter(isFontRecommededFunction);
export const FONT_RECOMMENDED_FUNCTION_OPTIONS = FONT_RECOMMENDED_FUNCTIONS.map(
    (value) => ({
        value,
        label: FontRecommededFunction[value],
    })
);
